import { defineMessages } from 'react-intl';

export default {
  ...defineMessages({
    classType: {
      id: 'schedules.form.class-type',
      defaultMessage: 'Class type',
    },
    recurring: {
      id: 'schedules.form.recurring',
      defaultMessage: 'Recurring',
    },
    oneTime: {
      id: 'schedules.form.one-time',
      defaultMessage: 'One-time',
    },
    date: {
      id: 'schedules.form.date',
      defaultMessage: 'Date',
    },
    startDate: {
      id: 'schedules.form.start-date',
      defaultMessage: 'Start date',
    },
    endDate: {
      id: 'schedules.form.end-date',
      defaultMessage: 'End date',
    },
    draft: {
      id: 'schedules.form.status.draft',
      defaultMessage: 'Draft',
    },
    cancelled: {
      id: 'schedules.form.status.canceled',
      defaultMessage: 'Canceled',
    },
    datePassed: {
      id: 'schedules.form.status.date-passed',
      defaultMessage: 'Date passed',
    },
    title: {
      id: 'schedules.form.title',
      defaultMessage: 'Add class schedule',
    },
    cpSpots: {
      id: 'schedules.form.cp-spots',
      defaultMessage: 'CP spots',
    },
    capacity: {
      id: 'schedules.form.capacity',
      defaultMessage: 'Capacity',
    },
    capacityTooltip: {
      id: 'schedules.form.capacity-tooltip',
      defaultMessage:
        'This is your direct capacity, not ClassPass spots. This will allow us to build better insights for your schedules.',
    },
    class: {
      id: 'schedules.form.class',
      defaultMessage: 'Class',
    },
    repeatOn: {
      id: 'schedules.form.repeat-on',
      defaultMessage: 'Repeat on',
    },
    instructor: {
      id: 'schedules.form.instructor',
      defaultMessage: 'Staff',
    },
    duration: {
      id: 'schedules.form.duration',
      defaultMessage: 'Duration (minutes)',
    },
    startTime: {
      id: 'schedules.form.start-time',
      defaultMessage: 'Start time',
    },
    addMoreStartTimes: {
      id: 'schedules.form.add-more-start-times',
      defaultMessage: 'Add more start times',
    },
    singleDayExceptions: {
      id: 'schedules.form.single-day-exceptions',
      defaultMessage: 'Single day exceptions',
    },
    addSingleDayException: {
      id: 'schedules.form.add-more-single-day-exceptions',
      defaultMessage: 'Add more single day exceptions',
    },
  }),
  validator: defineMessages({
    requiredField: {
      id: 'schedules.form.validator.required',
      defaultMessage: 'This field is required',
    },
    classDescriptionRequired: {
      id: 'schedules.form.classDescription.required',
      defaultMessage: 'Class description is required.',
    },
    alreadySelectedTime: {
      id: 'schedules.form.validator.already-selected-time',
      defaultMessage: 'This start time already exists',
    },
    dateInThePast: {
      id: 'schedules.form.validator.date-in-the-past',
      defaultMessage: 'Date cannot be in the past',
    },
    singleDayExceptionDaysDuplicated: {
      id: 'schedules.form.validator.single-day-exceptions.duplicated',
      defaultMessage: 'This list should not contain duplicates',
    },
    singleDayExceptionDaysOutOfRange: {
      id: 'schedules.form.validator.single-day-exceptions.out-of-range',
      defaultMessage: 'Single day exceptions should be between the start date and end date',
    },
  }),
  footer: defineMessages({
    discardChanges: {
      id: 'schedules.form.footer.discard-changes',
      defaultMessage: 'Discard changes',
    },
    deleteSchedule: {
      id: 'schedules.form.footer.delete-schedule',
      defaultMessage: 'Delete',
    },
    saveDraft: {
      id: 'schedules.form.footer.save-draft',
      defaultMessage: 'Save as draft',
    },
    publish: {
      id: 'schedules.form.footer.publish',
      defaultMessage: 'Save & publish',
    },
    save: {
      id: 'schedules.form.footer.save',
      defaultMessage: 'Save',
    },
  }),
  inputs: {
    capacity: defineMessages({
      notSpecified: {
        id: 'schedules.form.inputs.capacity.not-specified',
        defaultMessage: 'Not specified',
      },
    }),
    class: defineMessages({
      select: {
        id: 'schedules.form.inputs.class.select',
        defaultMessage: 'Select class',
      },
      add: {
        id: 'schedules.form.inputs.class.add',
        defaultMessage: '+ Add new class',
      },
    }),
    instructor: defineMessages({
      selectInstructor: {
        id: 'schedules.form.inputs.instructor.label',
        defaultMessage: 'Select staff',
      },
      add: {
        id: 'schedules.form.inputs.instructor.add',
        defaultMessage: '+ Add new staff',
      },
    }),
    isNoEndDate: defineMessages({
      noEndDate: {
        id: 'schedules.form.inputs.is-no-end-date.no-end-date',
        defaultMessage: 'No end date',
      },
    }),
  },
  modals: {
    ...defineMessages({
      cancel: {
        id: 'schedules.form.modals.cancel',
        defaultMessage: 'Cancel',
      },
      close: {
        id: 'schedules.form.modals.close',
        defaultMessage: 'Close',
      },
      save: {
        id: 'schedules.form.modals.save',
        defaultMessage: 'Save',
      },
      submit: {
        id: 'schedules.form.modals.submit',
        defaultMessage: 'Submit',
      },
    }),
    addClass: defineMessages({
      title: {
        id: 'schedules.form.modals.add-class.title',
        defaultMessage: 'Add new class',
      },
      labelClassName: {
        id: 'schedules.form.modals.add-class.label-class-name',
        defaultMessage: 'Class name',
      },
      placeholderClassName: {
        id: 'schedules.form.modals.add-class.placeholder-class-name',
        defaultMessage: 'Boot Camp',
      },
      labelClassDescription: {
        id: 'schedules.form.modals.add-class.label-class-description',
        defaultMessage: 'Class description',
      },
      placeholderClassDescription: {
        id: 'schedules.form.modals.add-class.placeholder-class-description',
        defaultMessage:
          'Your description helps members understand what to expect in class - be specific and detailed. We recommend a description of at least one or two sentences.',
      },
    }),
    addInstructor: defineMessages({
      title: {
        id: 'schedules.form.modals.add-instructor.title',
        defaultMessage: 'Add new staff',
      },
      labelFirstName: {
        id: 'schedules.form.modals.add-instructor.label-first-name',
        defaultMessage: 'First Name',
      },
      labelLastName: {
        id: 'schedules.form.modals.add-instructor.label-last-name',
        defaultMessage: 'Last Name',
      },
    }),
    deleteSchedule: {
      ...defineMessages({
        title: {
          id: 'schedules.form.modals.delete-schedule.title',
          defaultMessage: 'Are you sure you want to delete this class schedule?',
        },
      }),
      terminationTypes: defineMessages({
        delete: {
          id: 'schedules.form.modals.delete-schedule.termination-types.delete',
          defaultMessage:
            'All schedule instances associated with this class will be permanently deleted. If you want to cancel a single schedule instance, please do so from the <a>Daily Schedule section</a>.',
        },
        end_after_last_active_reservation: {
          id: 'schedules.form.modals.delete-schedule.termination-types.end-after-last-active-reservation',
          defaultMessage:
            'Since this class schedule has upcoming reservations, all schedule instances associated with this class will be permanently deleted after the last reservation. If you want to cancel a single schedule instance, please do so from the <a>Daily Schedule section</a>.',
        },
        end_now: {
          id: 'schedules.form.modals.delete-schedule.termination-types.end-now',
          defaultMessage:
            'The end date of this class schedule will be set to today. If you want to cancel a single schedule instance, please do so from the <a>Daily Schedule section</a>.',
        },
      }),
    },
    publishScheduleDraft: defineMessages({
      title: {
        id: 'schedules.form.modals.publish-schedule-draft.title',
        defaultMessage: 'Publish schedule',
      },
      confirmation: {
        id: 'schedules.form.modals.publish-schedule-draft.confirmation',
        defaultMessage: 'Are you sure you want to publish this draft schedule?',
      },
    }),
    scheduleConflicts: defineMessages({
      title: {
        id: 'schedules.form.modals.schedule-conflicts.title',
        defaultMessage: 'Schedule conflict',
      },
      description: {
        id: 'schedules.form.modals.schedule-conflicts.description',
        defaultMessage:
          'Found conflicting active class schedule with same start date, start time, class, staff in given venue with following schedules',
      },
    }),
  },
};
